import axios from "axios";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all press data */
export const getAllPressData = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/press`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/* Create press data */
export const createPressData = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/press`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/* Update press data */
export const updatePressData = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/press/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};


// --------------------------------------------------------------------------

/* Fetch all press news data */
export const getAllPressNewsData = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/press-news`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/* Create press news data */
export const createPressNewsData = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/press-news`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

/* Update press news data */
export const updatePressNewsData = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/press-news/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getPressNewsById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/press-news/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

/* Delete press news data */
export const deletePressNewsData = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/press-news/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};